import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { MorphingPlusMinusIcon } from '@/components/ui/MorphingCartIcon';
import { handleWhatsAppClick } from '../lib/whatsappTelemetry.js';

const faqs = [
  {
    q: 'כמה זמן לוקח הייצור?',
    a: 'זמן האספקה המוצהר הוא 5–10 ימי עבודה ממועד אישור ההזמנה והגשת הקבצים. זהו זמן משוער שעשוי להשתנות לפי היקף ההזמנה, זמינות חומרים ואילוצי ייצור ושילוח.'
  },
  {
    q: 'מהיכן ניתן לאסוף הזמנות מוכנות?',
    a: 'כתובתנו: רחוב האורגים 32, חולון.'
  },
  {
    q: 'מהי הכמות המינימלית?',
    a: 'כמות מינימלית היא 1 יחידה, אך ישנם מבצעים לכמויות גדולות שמופיעים בחישוב המחיר.'
  },
  {
    q: 'אילו פורמטים של קבצים מקובל להעלות?',
    a: 'PNG, JPG, ו-PDF רצויים. עבור איכות מיטבית: עדיף לצרף קובץ ללא רקע. זיכרו: ככל שהתמונה באיכות יותר טובה, כך גם ההדפסה תהיה יותר איכותית.  '
  },
  
  {
    q: 'איך חושבת עלות המשלוח?',
    a: 'המשלוח מחושב כ-₪60 כולל מע״מ לכל 50 פריטים (מעוגל כלפי מעלה).'
  },
  
  {
    q: 'מהי מדיניות ההחזרים?',
    a: 'החזרות והחלפות כפופות למדיניות האתר — מוצרים מותאמים אישית אינם ניתנים להחזרה ללא פגם ייצור.'
  },
  {
    q: 'אילו שיטות תשלום נתמכות?',
    a: 'כרטיסי אשראי, ביט, פייבוקס,תשלום מקוון וחשבונית לחברות (בהתאם להסדר).' 
  },
  {
    q: 'איך ליצור קשר לתמיכה?',
    a: 'ניתן לפנות דרך ווטסאפ בכפתור קישור למעלה. או לשלוח מייל ל-info@printeam.co.il',
    content: (
      <>
        ניתן לפנות דרך{' '}
        <a
          href="https://wa.me/972503969640?text=%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%90%D7%A0%D7%99%20%D7%9E%D7%A2%D7%95%D7%A0%D7%99%D7%99%D7%9F%20%D7%9C%D7%94%D7%93%D7%A4%D7%99%D7%A1%20%D7%A2%D7%9C"
          onClick={(event) => handleWhatsAppClick(event, 'faq')}
          onAuxClick={(event) => handleWhatsAppClick(event, 'faq')}
          className="font-medium text-blue-600 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          ווטסאפ
        </a>
        {' '}בכפתור הקישור למעלה, או לשלוח מייל ל-
        <a href="mailto:info@printeam.co.il" className="font-medium text-blue-600 hover:underline">
          info@printeam.co.il
        </a>
        .
      </>
    )
  },
  {
    q: 'האם יש מבצעים לכמויות גדולות?',
    a: 'כן — תעריפי יחידה יורדים ככל שהכמות עולה; פירוט מופיע בחישוב המחיר בדף המוצר.'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="min-h-screen py-12">
      <Helmet>
        {/* FAQPage structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: f.a
              }
            }))
          })}
        </script>
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">שאלות נפוצות</h1>
        <div className="space-y-4">
          {faqs.map((item, i) => (
            <div key={i} className="overflow-hidden rounded-xl bg-white shadow ring-1 ring-gray-100">
              <h2>
                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-right"
                  aria-expanded={openIndex === i}
                  aria-controls={`faq-panel-${i}`}
                  onClick={() => setOpenIndex((current) => (current === i ? null : i))}
                >
                  <span className="text-lg font-semibold text-gray-900">{item.q}</span>
                  <span className="text-gray-400">
                    <MorphingPlusMinusIcon expanded={openIndex === i} />
                  </span>
                </button>
              </h2>
              <div
                id={`faq-panel-${i}`}
                className={`border-t border-gray-100 px-6 py-5 text-gray-700 ${openIndex === i ? 'block' : 'hidden'}`}
              >
                <p>{item.content || item.a}</p>
              </div>
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
}
